/* eslint-disable prettier/prettier */
import { api } from "./axios";

export const FolderService = {
  getAllWithHierarchy: async () => {
    const res = await api.get('/folders/options');
    return res.data;
  },
  getAll: async () => {
    const res = await api.get('/folders');
    return res.data;
  },
  create: async (data: any) => {
    const res = await api.post('/folders', data);
    return res.data;
  },
  update: async (id: string, data: any) => {
    const res = await api.patch(`/folders/${id}`, data);
    return res.data;
  },
  delete: async (id: string) => {
    const res = await api.delete(`/folders/${id}`);
    return res.data;
  },
};
